import { useRecoilValue } from "recoil";
import { taskListAtom } from "recoil/taskListAtom";

export default function useGetMeditationRecordVersion() {
  const taskListState = useRecoilValue(taskListAtom);

  const isRoutineAvailable = taskListState.some(
    (element) => ["8-2-A"].includes(element.taskId) && element.lastDoneAt
  );
  const isCopingAvailable = taskListState.some(
    (element) => ["8-8-A"].includes(element.taskId) && element.lastDoneAt
  );
  return { isRoutineAvailable, isCopingAvailable };
}
